module.exports = __webpack_public_path__ + "static/media/dorothee.1dadca1f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/dorothee.gif
// module id = 215
// module chunks = 0